import React from 'react';
import Type from 'prop-types';
import CurrencyInput from '../../CurrencyInput';

const CurrencyField = (props) => {
  const {
    field,
    form: { setFieldTouched, setFieldValue },
    ...rest
  } = props;

  const handleChange = (newValue) => {
    if (newValue === '' || newValue === null || newValue === undefined) {
      setFieldValue(field.name, '');
      return;
    }

    const value = Number(newValue);
    setFieldValue(field.name, Number.isNaN(value) ? '' : value);
  };

  const handleBlur = () => {
    setFieldTouched(field.name, true);

    if (field.value === '' || field.value === null || field.value === undefined) {
      setFieldValue(field.name, '');
      return;
    }

    const value = Number(field.value);
    setFieldValue(field.name, Number.isNaN(value) ? '' : value);
  };

  return (
    <CurrencyInput
      {...field}
      {...rest}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

CurrencyField.propTypes = {
  form: Type.shape({
    // eslint-disable-next-line react/forbid-prop-types
    errors: Type.object,
    setFieldTouched: Type.func,
    setFieldValue: Type.func,
  }).isRequired,
  field: Type.shape({
    name: Type.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    value: Type.any,
  }).isRequired,
};

export default CurrencyField;
